// utils
export const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'short' });
    const time = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true });
    return `${day} ${month} ${time}`;
};

export const formatEndDate = (start, end) => {
    if (!start && !end) return '';
    const startDate = new Date(start);
    const endDate = new Date(end);
    const day = endDate.getDate();
    const month = endDate.toLocaleString('default', { month: 'short' });
    const time = endDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true });

    if (startDate.getFullYear() === endDate.getFullYear() &&
        startDate.getMonth() === endDate.getMonth() &&
        startDate.getDate() === endDate.getDate()) {
        console.log('Both dates fall on the same calendar day.');
        return `${time}`
    }
    return `${day} ${month} ${time}`;
};

export const dropdownFormatter = (event) => {
    const { event_name, start_time, end_time } = event;

    if (event_name === "") {
        if (!start_time && !end_time) {
            return "NA";
        } else if (!start_time) {
            return `NA (NA - ${formatDate(end_time)})`;
        } else if (!end_time) {
            return `NA (${formatDate(start_time)})`;
        } else {
            return `NA (${formatDate(start_time)} - ${formatDate(end_time)})`;
        }
    } else {
        if (!start_time && !end_time) {
            return event_name;
        } else if (!start_time) {
            return `${event_name} (NA - ${formatDate(end_time)})`;
        } else if (!end_time) {
            return `${event_name} (${formatDate(start_time)})`;
        } else {
            return `${event_name} (${formatDate(start_time)} - ${formatDate(end_time)})`;
        }
    }
};

export const convertDateTime = (inputStr) => {
    if (inputStr === "" && inputStr === undefined) {
        return "";
    }

    const inputDate = new Date(inputStr + ` ${new Date().getFullYear()}`);

    const year = inputDate.getFullYear();
    const month = String(inputDate.getMonth() + 1).padStart(2, '0');
    const day = String(inputDate.getDate()).padStart(2, '0');
    const hours = String(inputDate.getHours()).padStart(2, '0');
    const minutes = String(inputDate.getMinutes()).padStart(2, '0');
    const seconds = "00";

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

export const timeFormatter = (event) => {
    const { start_time, end_time } = event;

    if (!start_time && !end_time) {
        return "NA";
    } else if (!start_time) {
        return `NA - ${formatDate(end_time)}`;
    } else if (!end_time) {
        return `${formatDate(start_time)}`;
    } else {

        return `${formatDate(start_time)} - ${formatEndDate(start_time, end_time)}`;
    }
};

export const isUndefined = (mixed_var) => {
    if (typeof mixed_var === "undefined" || mixed_var === undefined || mixed_var === null) {
        return true;
    }
    mixed_var += '';
    if (mixed_var === 'undef' || mixed_var === 'undefined') return true;
    return false;
};

export const empty = (mixed_var) => {
    // Checks if the argument variable is empty
    // undefined, null, false, number 0, empty string,
    // string "0", objects without properties and empty arrays
    // are considered empty
    var undef, key, i, len;
    var emptyValues = [undef, undefined, null, false, 0, "", "0"];

    for (i = 0, len = emptyValues.length; i < len; i++) {
        if (mixed_var === emptyValues[i]) {
            return true;
        }
    }

    if (typeof mixed_var === "object") {
        for (key in mixed_var) {
            // TODO: should we check for own properties only?
            //if (mixed_var.hasOwnProperty(key)) {
            return false; //non-empty object or array
            //}
        }
        return true;
    }

    return false;
};

export const isEmpty = (str) => {
    if (isUndefined(str)) return true;

    if (!empty(str)) {
        str += '';
        if (str === 'undefined') return true;
        str.replace(/^\s+|\s+$/g, '');
        return (str === '' || str === 0);
    }
    return true;
};

export const extractDataFromArray = (dataArr, paramsArr, defaultRetVal = '') => {
    var data = defaultRetVal;
    try {
        if (!isEmpty(dataArr) && !isUndefined(paramsArr)) {
            data = dataArr;
            paramsArr = typeof paramsArr === "string" ? paramsArr.split(".") : paramsArr
            var len = paramsArr.length;
            for (var i = 0; i < len; ++i) {
                if (!isUndefined(paramsArr[i])) {
                    data = data[paramsArr[i]];
                }
            }
        }
        if (isUndefined(data)) {
            data = defaultRetVal;
        }
    }
    catch (e) {
        data = defaultRetVal;
    }

    return data;
};


export const logoutCookies = () => {
    eraseCookie("userwork");
    eraseCookie("login");
    eraseCookie("email");
    eraseCookie("uid");
    eraseCookie("sid");
    eraseCookie("bulk_folders-grid-layout");
    eraseCookie("qr_folders-grid-layout");

    logoutAllCookies();

    // removal of authtk
    localStorage.removeItem("Authtk");
};

export const logoutAllCookies = () => {
    var pairs = document.cookie.split(";");
    for (var i = 0; i < pairs.length; ++i) {
        var pair = pairs[i].split("=");
        var c = (pair[0] + '').trim();

        let prefix = "qr-";
        if (isDev()) {
            prefix += 'DEV-';
        } else if (isLocal()) {
            prefix += 'LOCAL-';
        } else if (isStag()) {
            prefix += 'STAG-';
        }

        if (c.startsWith(prefix)) {
            c = c.replace(prefix, '');
            if (c !== '' && c !== 'B' && c !== 'b' && c !== 'qrcc_ck_pref') {
                eraseCookie(c);
            }
        }
    }
};

export const eraseCookie = (name) => {

    createCookie(name, '', 0);

    let prefix = "qr-";
    if (isDev()) {
        prefix += 'DEV-';
    } else if (isLocal()) {
        prefix += 'LOCAL-';
    } else if (isStag()) {
        prefix += 'STAG-';
    }

    document.cookie = prefix + name + '=;max-age=0;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT;domain=.qrcodechimp.com';
    document.cookie = prefix + name + '=;max-age=0;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT;domain=.www.qrcodechimp.com';
    document.cookie = prefix + name + '=;max-age=0;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT;domain=.' + window.location.host;
    document.cookie = prefix + name + '=;max-age=0;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
};

export const createCookie = (name, value, days) => {
    let expires;
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toGMTString();
    }
    else expires = "";
    let prefix = "qr-";
    if (isDev()) {
        prefix += 'DEV-';
    } else if (isLocal()) {
        prefix += 'LOCAL-';
    } else if (isStag()) {
        prefix += 'STAG-';
    }
    document.cookie = prefix + name + "=" + value + expires + "; path=/; domain=." + window.location.host;
};

export const isDev = () => {
    const subdomain = window.location.host.split('.')[0];
    return subdomain === 'dev' || subdomain === 'qd' || subdomain === 'dev-dashboard';
};

export const isStag = () => {
    const subdomain = window.location.host.split('.')[0];
    return subdomain === 'sm' || subdomain === 's' || subdomain === 's-dashboard';
};

export const isLocal = () => {
    const subdomain = window.location.host.split('.')[0];
    return subdomain === 'l' || subdomain === 'l-dashboard';
};

export const signInCallback = (requestData, response) => {
    window.user_info = extractDataFromArray(response, ["data"], {});
    const token = extractDataFromArray(response, ["data", "authToken"], "");
    if (!isEmpty(token)) {
        localStorage.setItem("Authtk", token);
    }
    window.location.replace("/event-scanner/event-slots");
};

// export const isUserLoggedIn = () => {
//     return (typeof user_info != "undefined" && !empty(extractDataFromArray(user_info, ['email'], false))) || amILoggedIn();
// }

// export const amILoggedIn = () => {
//     if ($(".user_profile_header").hasClass("loggedIn") || sharedUserLoggedIn()) {
//         return true;
//     }
//     return false;
// }

// export const sharedUserLoggedIn = () => {
//     return (typeof __shared_page_loggedin != "undefined" && __shared_page_loggedin == 1);
// }

export const no_event_src = () => {
    if (isLocal() || isDev()) return "";
    if (isStag()) return "https://s-cdn0070.qrcodechimp.com";
    return "https://cdn0070.qrcodechimp.com";
};

// Validations

// Function to validate email input
export const validEmail = (strInp) => {
    const emailRegex = /^(mailto:)?[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i;
    return emailRegex.test(strInp)
};

